<ng-container *ngIf="measureType$ | async as measureType">

  <ng-container *ngIf="group.rows.length > 1; else singleAppliance">

    <app-consumption-line (click)="selectGroup(group)"
      [name]="PowerLines[group.rows[0].module.source_type]?.name | LANG"
      [icon]="PowerLines[group.rows[0].module.source_type]?.icon"
      [value]="group.value | toDisplayValue : measureType"
      [color]="group.color"
      [ratio]="group.ratio * 100"
      [hasArrow]="true"
      [measureType]="measureType">
    </app-consumption-line>

  </ng-container>

  <ng-template #singleAppliance>

    <app-consumption-line
      [name]="group.rows[0].module.name | LANG"
      [icon]="PowerLines[group.rows[0].module.source_type]?.icon"
      [value]="group.value | toDisplayValue : measureType"
      [color]="group.color"
      [ratio]="group.ratio * 100"
      [hasArrowWhiteSpace]="hasArrowSpace(groups$ | async)"
      [measureType]="measureType">
    </app-consumption-line>

  </ng-template>

</ng-container>
